import { MIN_IMAGE_DIMENSION_SIZE, UPLOAD_ERROR_MESSAGES } from 'src/app/shared/hooks/uppyUploader';

import type { Action } from './actions';
import type { ImageUploadState } from './context';

// eslint-disable-next-line complexity
export function imageUploadReducer(state: ImageUploadState, action: Action): ImageUploadState {
	switch (action.type) {
		case 'SET_IMAGE': {
			const { image, uploader } = action.payload;

			if (image && image.includes('data:image/') && !uploader.getFile()) uploader.addFile('image/jpeg', image);

			const newImage = action.payload.image || undefined;
			return {
				...state,
				image: newImage,
				imageChanged: newImage !== state.image && !action.payload.initialLoad,
				fileType: typeof image === 'string' ? image.substring('data:image/'.length, image.indexOf(';base64')) : null,
				errorMessage: null,
				cropper: newImage ? state.cropper : undefined,
			};
		}
		case 'SET_ERROR': {
			const { errorMessage } = action.payload;

			return {
				...state,
				errorMessage,
			};
		}
		case 'SET_IMAGE_CROP': {
			const { img, skipDimensionCheck } = action.payload;
			const width = img?.w;
			const height = img?.h;

			if (
				!skipDimensionCheck &&
				((height && height < MIN_IMAGE_DIMENSION_SIZE.HEIGHT) || (width && width < MIN_IMAGE_DIMENSION_SIZE.WIDTH))
			) {
				return { ...state, imageCrop: img, errorMessage: UPLOAD_ERROR_MESSAGES.IMAGE_TOO_SMALL };
			}
			return { ...state, imageCrop: img };
		}
		case 'cropper/instance': {
			return {
				...state,
				cropper: action.payload.cropper,
			};
		}
		default: {
			return state;
		}
	}
}
